<div class="flex flex-col justify-center tix-auth">
  <!-- Error Alert -->
  <div
    *ngIf="hasReset"
    class="tix-login-error-placeholder p-4 bg-green-200 rounded-sm mb-2"
  >
    <span class="text-sm font-medium text-green-700">
      You'll receive an email with the instructions if
      <strong>{{ emailControl.value }}</strong> is associated to an
      account</span
    >
  </div>
  <!-- Sign In Section -->
  <div class="flex flex-col space-y-4">
    <div class="flex flex-col space-y-2 mb-4">
      <!-- Title -->
      <h4 class="text-2xl text-black font-semibold">Forget password?</h4>
      <!-- Subtitle -->
      <p class="text-[#72787E] w-3/4">
        Enter yout email and we'll send you instructions on how to reset your
        password.
      </p>
    </div>
    <!-- Form -->
    <form (submit)="handleSubmit($event)" class="flex flex-col">
      <!-- Email Input -->
      <mat-form-field
        hideRequiredMarker="true"
        [ngClass]="{ 'pointer-events-none': hasReset }"
      >
        <mat-label>Email</mat-label>
        <input
          matInput
          type="email"
          [readonly]="hasReset"
          [formControl]="emailControl"
        />
        <mat-error *ngIf="emailControl.hasError('required')"
          >The email address is required</mat-error
        >
        <mat-error *ngIf="emailControl.hasError('email')"
          >Invalid email address</mat-error
        >
      </mat-form-field>

      <!-- Send Instructions Button -->
      <button
        matRipple
        class="w-full p-3 flex items-center space-x-2 cursor-pointer justify-center rounded-md bg-primary text-white font-medium text-md hover:bg-matprimary-700"
        [disabled]="!canReset || hasReset || isLoading"
        type="submit"
      >
        <span *tixBtnLoading="isLoading"></span>
        <span>{{ isLoading ? 'Loading...' : 'Send Instructions' }}</span>
      </button>
    </form>
    <!-- OR Divider -->
    <div class="my-4 flex items-center gap-4">
      <hr class="w-full border-[#72787E4D]" />
      <p class="text-sm text-[#72787E] text-center">or</p>
      <hr class="w-full border-[#72787E4D]" />
    </div>
    <!-- Back to login Button -->
    <button
      matRipple
      class="w-full p-3 flex items-center justify-center rounded-md border-2 border-primary text-primary font-medium text-md hover:bg-matprimary-50"
      routerLink="../login"
    >
      Back to login
    </button>
  </div>
</div>
